<template>
  <div id="app">
    <PrivacyAgreement :query="query" v-if="path.includes('agreement')" />
    <mainContent v-else msg="Welcome to Your Vue.js App" />
  </div>
</template>

<script>
import mainContent from "./components/mainContent.vue";
import PrivacyAgreement from "./components/PrivacyAgreement.vue";
// 设计稿宽度基准
const designWidth = 375; // 根据你的设计稿调整

// 基准 font-size
const baseSize = 12; // 通常设置为12px，使得1rem = 12px

function setRem() {
  // 获取当前屏幕的宽度
  const screenWidth = document.documentElement.clientWidth;

  // 计算 scale 比例，基于设计稿和当前屏幕宽度
  const scale = screenWidth / designWidth;

  // 设置根元素的 font-size
  document.documentElement.style.fontSize = `${baseSize * scale}px`;
}

// 初始化设置
setRem();

// 窗口大小变化时重新设置
window.onresize = setRem;
export default {
  name: "app",
  components: {
    mainContent,
	PrivacyAgreement
  },
  data() {
    return {
      someValue: null,
      path: "",
      query: {},
    };
  },
  created() {
    this.path = this.$route.path;
    this.query = this.$route.query;
    console.log("初始参数", this.$route);
  },
  mounted() {
    const path = window.location.pathname; // 获取路径
    const pathSegments = path.split("/"); // 按 / 切分路径
    const id = pathSegments[pathSegments.length - 1]; // 假设最后一个部分是你需要的参数
    console.log(id); // 获取路径参数 id 的值
  },
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>
